import React from "react";
import Button from "@kiwicom/orbit-components/lib/Button";
import Router from "next/router";
import { SignPost } from "./Contract/signpost";
import getAuthorization from "./helpers/getAuthorization";
import { LINKS } from "./Contract/links";

const Index = ({ isExport }) => {
  const { token } = getAuthorization();

  return (
    <>
      {token ? (
        <SignPost isExport={isExport} />
      ) : (
        <Button onClick={() => Router.push(LINKS.login(isExport))}>
          Přihlásit se
        </Button>
      )}
    </>
  );
};

export default Index;
